// extracted by mini-css-extract-plugin
export default {"home_modal":"index_home_modal__QCcXh","ant_modal_content":"index_ant_modal_content__JPV2U","search_logo":"index_search_logo__YxoZg"};